import React, { useEffect, useState } from "react";

const BaseModalAnimated = ({ modal, setModal, children, ...props }) => {
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (modal.show) {
            setShowModal(true);
        }
    }, [modal.show]);

    const closeModal = () => {
        setShowModal({ ...modal, show: false });
        setTimeout(() => {
            setModal({ show: false, id: null });
        }, 300);
    };

    return (
        <>
            {modal.show ? (
                <>
                    {/* Overlay */}
                    <div className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm transition-opacity duration-300" />

                    {/* Modal */}
                    <div
                        className={`
              fixed inset-0 z-50
              flex items-center justify-center
              px-4
              transition-all duration-300 ease-out
              ${showModal
                                ? "opacity-100 scale-100 translate-y-0"
                                : "opacity-0 scale-95 translate-y-4"}
            `}
                    >
                        <div className="relative w-full sm:w-[80%] md:w-[55%] lg:w-[50%] max-w-3xl">
                            <div className="relative flex flex-col w-full rounded-xl bg-cs-surface shadow-xl border border-cs-border overflow-hidden">

                                {/* Header */}
                                <div
                                    className={`
                    flex items-center justify-between
                    px-6 py-4
                    ${modal.user ? 'border-b border-cs-border' : ''}
                  `}
                                >
                                    <h3 className="text-lg font-semibold text-cs-dark">
                                        {modal.title}
                                    </h3>

                                    <button
                                        onClick={closeModal}
                                        className="
                      flex items-center justify-center
                      h-8 w-8
                      rounded-full
                      text-cs-muted
                      hover:text-cs-dark
                      hover:bg-cs-bg-alt
                      transition-colors
                      focus:outline-none
                    "
                                    >
                                        <svg
                                            className="h-5 w-5"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M6 18L18 6M6 6l12 12"
                                            />
                                        </svg>
                                    </button>
                                </div>

                                {/* Body */}
                                <div className="px-6 py-4">
                                    {children}
                                </div>

                            </div>
                        </div>
                    </div>
                </>
            ) : null}
        </>
    );
};

export default BaseModalAnimated;
